<mpro-loading *ngIf="dataService.getIsLoading() | async"></mpro-loading>
<article class="consumer">
  <div>
    <h2>
      {{ dataFilters.regionSelection.getName() }} - {{ dataFilters.year }}
    </h2>
    <mpro-tags style="margin: 15px 0px"></mpro-tags>
  </div>
  <div *ngIf="sizeOfPrizeGeneralInfo$ | async as sizeOfPrizeGeneralInfo">
    <img id="profile-img" src="assets/size_of_prize_two.svg" />
    <p
      [ngStyle]="{
        'font-size': isFromSizeOfPrize ? '1.25rem' : '0.85rem'
      }"
    >
      The selected demand size of the prize in
      <span>{{ sizeOfPrizeGeneralInfo.year }}</span> is
      <span>${{ sizeOfPrizeGeneralInfo.amount | formatNumber }}.</span>
      The CAGR growth rate is
      <span
        class="title blue"
        [class.red]="sizeOfPrizeGeneralInfo.percentage < 0"
        [class.green]="sizeOfPrizeGeneralInfo.percentage > 0"
        >{{ sizeOfPrizeGeneralInfo.percentage | formatNumber }}%</span
      >
      from today.
    </p>
  </div>
</article>
